// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fm37fSZasFbOk4IdBwLl {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
  font-size: 12px;
  color: var(--sl-fg-base, #1f1f1f);
  transition: opacity 0.15s;
}

.fm37fSZasFbOk4IdBwLl:focus-visible {
  outline: 2px solid #0366dd;
  outline-offset: 2px;
  border-radius: 2px;
}

.MdJTscZGeIP9X_eeK0HU {
  opacity: 0.4;
}

.MdJTscZGeIP9X_eeK0HU span {
  text-decoration: line-through;
}

.cWa0fQ41I2UongKFZK2T {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/BudgetConsumptionReport/ChartLegend/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".legendItem {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 0;\n  font-size: 12px;\n  color: var(--sl-fg-base, #1f1f1f);\n  transition: opacity 0.15s;\n}\n\n.legendItem:focus-visible {\n  outline: 2px solid #0366dd;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.legendItemHidden {\n  opacity: 0.4;\n}\n\n.legendItemHidden span {\n  text-decoration: line-through;\n}\n\n.legendSquare {\n  flex-shrink: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendItem": `fm37fSZasFbOk4IdBwLl`,
	"legendItemHidden": `MdJTscZGeIP9X_eeK0HU`,
	"legendSquare": `cWa0fQ41I2UongKFZK2T`
};
export default ___CSS_LOADER_EXPORT___;
